import { Receipt, Wallet, FileClock } from 'lucide-react';

import { DashboardLayout } from '@/components/dashboard/DashboardLayout';
import { PageHeader } from '@/components/dashboard/PageHeader';
import { StatCard } from '@/components/dashboard/StatCard';

const invoices = [
  {
    id: 'INV-2026-041',
    brand: 'Orange CI',
    amount: '1 200 000 FCFA',
    date: '2026-04-01',
    status: 'Payée',
  },
  { id: 'INV-2026-042', brand: 'MTN', amount: '850 000 FCFA', date: '2026-04-05', status: 'Payée' },
  {
    id: 'INV-2026-043',
    brand: 'Ramco',
    amount: '450 000 FCFA',
    date: '2026-04-12',
    status: 'En attente',
  },
  {
    id: 'INV-2026-044',
    brand: 'Yango',
    amount: '650 000 FCFA',
    date: '2026-04-18',
    status: 'En attente',
  },
  {
    id: 'INV-2026-045',
    brand: 'Prosuma',
    amount: '1 100 000 FCFA',
    date: '2026-04-20',
    status: 'Payée',
  },
];

const AdminBilling = () => (
  <DashboardLayout
    role="admin"
    user={{ name: 'Équipe Winkô', subtitle: 'Super Admin', initials: 'WK' }}
  >
    <PageHeader
      title="Facturation"
      subtitle="Revenus, factures et statut des paiements partenaires."
    />
    <div className="grid gap-4 sm:grid-cols-3">
      <StatCard
        label="Revenus du mois"
        value="3,2 M FCFA"
        delta={{ value: '+18 % MoM', positive: true }}
        icon={Wallet}
        accent="emerald"
      />
      <StatCard label="Factures émises" value="24" icon={Receipt} accent="primary" />
      <StatCard
        label="En attente"
        value="2"
        delta={{ value: '1,1 M FCFA' }}
        icon={FileClock}
        accent="amber"
      />
    </div>
    <div className="mt-6 overflow-hidden rounded-2xl border border-border bg-card shadow-soft">
      <table className="w-full text-sm">
        <thead className="border-b border-border bg-muted/50">
          <tr className="text-left text-xs font-semibold uppercase tracking-wider text-muted-foreground">
            <th className="px-5 py-3">N°</th>
            <th className="px-5 py-3">Marque</th>
            <th className="px-5 py-3">Date</th>
            <th className="px-5 py-3 text-right">Montant</th>
            <th className="px-5 py-3">Statut</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-border">
          {invoices.map(i => (
            <tr key={i.id} className="hover:bg-muted/30">
              <td className="px-5 py-3 font-mono text-xs">{i.id}</td>
              <td className="px-5 py-3 font-medium">{i.brand}</td>
              <td className="px-5 py-3 text-muted-foreground">{i.date}</td>
              <td className="px-5 py-3 text-right font-semibold">{i.amount}</td>
              <td className="px-5 py-3">
                <span
                  className={
                    'inline-flex rounded-full border px-2.5 py-0.5 text-xs font-semibold ' +
                    (i.status === 'Payée'
                      ? 'border-emerald-500/30 bg-emerald-500/10 text-emerald-700'
                      : 'border-amber-500/30 bg-amber-500/10 text-amber-700')
                  }
                >
                  {i.status}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </DashboardLayout>
);

export default AdminBilling;
